import React from 'react';


export default function RecordInfo({record}){
    return <div className="recordInfo">
    {
        record.map((rec, index)=> {
            return    <div className="record_detail" key={index}>
            <h5>{rec.text}</h5>
            <div className="record_para">
                {rec?.date ? <p>{rec?.date}</p> : <></> }
                {rec?.time ? <p>{rec?.time}</p> : <></>}
                {rec?.symptom ?
                    rec?.symptom?.map((r, index)=>{
                        return  <p key={index}>{r}</p>
                    })
                    : <></>
                }
            </div>
        </div>
        })
    }
         
    </div>
}